import React from 'react';
import ActionMenu, { Option, Position } from './ActionMenu';

type OnClose = () => void;

type State = {
  shown: boolean;
  options?: Option[];
  children?: any;
  position?: Position;
  onClose?: OnClose;
};

type ActionType = 'show' | 'hide';
type Action = {
  type: ActionType;
  options?: Option[];
  children?: any;
  onClose?: OnClose;
  position?: Position;
};
type Dispatch = (action: Action) => void;

const ActionMenuDispatchContext = React.createContext<Dispatch | undefined>(
  undefined
);

function actionMenuReducer(state: State, action: Action) {
  switch (action.type) {
    case 'show': {
      return {
        shown: true,
        options: action.options,
        onClose: action.onClose,
        position: action.position,
        children: action.children
      };
    }
    case 'hide': {
      return { shown: false };
    }
  }
}

function ActionMenuProvider({ children }: { children: React.ReactNode }) {
  const [state, dispatch] = React.useReducer(actionMenuReducer, {
    shown: false
  });

  return (
    <ActionMenuDispatchContext.Provider value={dispatch}>
      <ActionMenu
        open={state.shown}
        position={state.position}
        options={state.options}
        onClose={() => {
          dispatch({ type: 'hide' });
        }}
        children={state.children}
      />
      {children}
    </ActionMenuDispatchContext.Provider>
  );
}

function useActionMenuDispatch() {
  const context = React.useContext(ActionMenuDispatchContext);
  if (context === undefined) {
    throw new Error('ActionMenuDispatch must be used with ActionMenuProvider');
  }
  return context;
}

export { ActionMenuProvider, useActionMenuDispatch };
